<template>
  <div class="sidebar">
    <div class="sidebar-top">
      <div class="top-title">
        MENU
      </div>
      <sidebar-toggle/>
    </div>
    <div class="sidebar-menu">
      <div class="menu" type="text" @click="onItemClick($t('route.profile'))">
        {{ $t('navbar.profile') }}
      </div>
      <div class="menu" type="text" @click="onItemClick($t('route.orders'))">
        {{ $t('navbar.lastorder') }}
      </div>
      <div class="menu" type="text" @click="onItemClick($t('route.cart'))">
        {{ $t('navbar.cart') }}
      </div>
      <div class="menu" type="text" @click="onBrowseClick($t('route.browse'), undefined)">
        {{ $t('navbar.browse') }}
      </div>
      <div class="menu" type="text" @click="onItemClick($t('route.promotions'))">
        {{ $t('navbar.promotions') }}
      </div>
      <div class="menu" type="text" @click="onItemClick($t('route.faq'))">
        {{ $t('navbar.faq') }}
      </div>
      <div class="menu" type="text" @click="onItemClick($t('route.contact'))">
        {{ $t('navbar.contactus') }}
      </div>
      <div class="menu" type="text" @click="onLogoutClick">
        {{ $t('navbar.logOut') }}
      </div>
    </div>
  </div>
</template>

<script>
import SidebarToggle from './SidebarToggle.vue'
import {
  TweenMax,
  Power4
} from 'gsap'
export default {
  name: 'sidebar',
  mounted () {
    TweenMax.set(this.$el, {
      x: -this.$el.offsetWidth
    })
  },
  components: {
    SidebarToggle
  },
  computed: {
    open () {
      return this.$store.getters.sidebar.opened
    }
  },
  watch: {
    open (open) {
      const dX = open ? 0 : -this.$el.offsetWidth
      TweenMax.to(this.$el, 0.6, {
        x: dX,
        ease: Power4.easeOut
      })
    }
  },
  methods: {
    onItemClick (name) {
      this.$store.dispatch('toggleSideBar')
      this.$router.push({ name, params: { id: 'all' } })
    },
    onBrowseClick (name, obj) {
      this.$store.dispatch('toggleSideBar')
      this.$router.push({ path: `/browse` })
    },
    onLogoutClick () {
      this.$store.dispatch('LogOut').then(res => {
        location.reload()// In order to re-instantiate the vue-router object to avoid bugs
      }).catch(err => {
        console.log(err)
        location.reload()
      })
    }
  }
}
</script>

<style lang="scss">
@import "@/styles/settings.scss";
.sidebar {
  position: fixed;
  left: 0;
  top: 0;
  width: 300px;
  height: 100vh;
  max-width: 90vw;
  background-color: $white-color;
  z-index: 99;
  .sidebar-top {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding-left: 20px;
    border-bottom: 1px solid #ccc;
    .top-title {
      font-size: 20px;
      font-weight: bold;
    }
  }
  .sidebar-menu {
    width: 100%;
    padding-top: 10px;
  }
  .menu {
    color: $black-color;
    cursor: pointer;
    display: block;
    font-size: 20px;
    font-weight: bold;
    padding: 10px 20px;
    transition: all 100ms ease-out;
    &:hover {
      color: $orange-color;
      transition: all 100ms ease-out;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Sidebar.vue